// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "js/" + chunkId + "-legacy." + {"37":"1438dcd5","592":"76b076f8"}[chunkId] + ".js"; };